
































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";
import { Cropper } from "vue-advanced-cropper";
import FormErrorsMixin from "@/mixins/FormErrors";

import ViewLoader from "@/components/Common/ViewLoader.vue";
import NavigationTabs from "@/components/Settings/Venue/NavigationTabs.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import BackButton from "@/components/Common/Buttons/BackButton.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import Error404 from "@/components/Common/Error404.vue";
import { IFacility, IVenue } from "@/interface";
import { AxiosResponse } from "axios";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    NavigationTabs,
    AlertBox,
    BackButton,
    InfoButton,
    Cropper,
    Error404
  }
})
export default class Images extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = ["image"];
  private noDataExist = false;
  private images: Array<File> = [];
  private facilities: Array<IFacility> = [];
  private selectedVenueId: string | null = null;
  private selectedVenue: IVenue | null = null;
  private showImageModal = false;
  private newUrl = require("@/assets/img/default-event.png");
  private newImage: File | null = null;
  private croppedImage: string | Blob | null = null;
  private errorMessage: string | null = null;
  private handlersClassProps: any = {
    east: "custom-handler",
    eastNorth: "custom-handler",
    north: "custom-handler",
    westNorth: "custom-handler",
    west: "custom-handler",
    westSouth: "custom-handler",
    south: "custom-handler",
    eastSouth: "custom-handler"
  };
  private linesClassProps: any = {
    east: "custom-horizontal-line",
    west: "custom-horizontal-line",
    south: "custom-vertical-line",
    north: "custom-vertical-line"
  };

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedVenueId = vm.$route.params.id;
      vm.getFacilities(() => {
        if (
          vm.selectedVenueId !== null &&
          vm.selectedVenueId !== undefined &&
          vm.selectedVenueId !== "default"
        ) {
          vm.getVenue(() => {
            vm.getImages(() => {
              //
            });
          });
        }
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    this.getFacilities(() => {
      if (
        this.selectedVenueId !== null &&
        this.selectedVenueId !== undefined &&
        this.selectedVenueId !== "default"
      ) {
        this.getVenue(() => {
          this.getImages(() => {
            //
          });
        });
      }
    });
    next();
  }

  private getFacilities(successCallback?: any): void {
    const endpoint: string = this.$partnerEndpoint("facilities/simplified");

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.facilities = response.data.data;
        if (!this.selectedVenueId || this.selectedVenueId === "default") {
          const selectedFacility = this.facilities.find(
            (facility: IFacility) =>
              facility.venues && facility.venues.length > 0
          );
          if (
            selectedFacility &&
            selectedFacility.venues &&
            selectedFacility.venues[0].id
          ) {
            this.selectedVenueId = `${selectedFacility.venues[0].id}`;
          }
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  private getVenue(successCallback?: any): void {
    this.loading = true;
    this.images = [];
    const endpoint: string = this.$partnerEndpoint(
      "venues/" + this.selectedVenueId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedVenue = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
        this.loading = false;
      });
  }

  private getImages(successCallback?: any): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "venues/" + this.selectedVenueId + "/images"
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.images = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((e: any) => {
        console.log(e);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private uploadVenueImage(successCallback?: any): void {
    if (this.loading || this.updating || !this.newImage) {
      return;
    }

    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "venues/" + this.selectedVenueId + "/images"
    );

    const formData = new FormData();
    if (this.croppedImage) {
      formData.append("image", this.croppedImage);
    }
    Api()
      .post(endpoint, formData, {
        headers: {
          "content-type": "multipart/form-data"
        }
      })
      .then(() => {
        this.getImages();
        swal("Success!", "The image was uploaded.", "success");
        this.closeModal();

        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((e: any) => {
        this.storeErrors(e.response.data.errors);

        if (e.response.status / 100 === 5) {
          if (e.response.status % 100 < 10) {
            this.errorMessage = "An error occurred.";
          } else {
            this.closeModal();
            swal({
              title: "Something wrong happened and the image was not uploaded",
              icon: "error",
              dangerMode: true
            });
          }
        }
        console.log(e);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private deleteVenueImage(imageId: number): void {
    if (this.loading || this.updating) {
      return;
    }
    swal({
      title: "Are you sure?",
      text: "The image will be deleted",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        this.updating = true;
        const endpoint: string = this.$partnerEndpoint(
          "venues/" + this.selectedVenueId + "/images/" + imageId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.getImages();
          })
          .catch((e: any) => {
            console.log(e);
          })
          .finally(() => {
            this.updating = false;
          });
      }
    });
  }

  private onImageFileChange(e: any): void {
    const file = e.target.files[0];
    var reader = new FileReader();
    reader.readAsDataURL(file);
    this.newUrl = URL.createObjectURL(file);
    this.newImage = file;
    this.croppedImage = file;
  }

  private openModal(): void {
    this.showImageModal = true;
  }

  private closeModal(): void {
    this.resetErrors();
    this.showImageModal = false;
    this.newUrl = require("@/assets/img/default-event.png");
    this.newImage = null;
    this.croppedImage = null;
    this.errorMessage = null;
  }

  private change({ canvas }: any): void {
    const dataURL = canvas.toDataURL();
    const blobBin = atob(dataURL.split(",")[1]);
    const array = [];
    for (let i = 0; i < blobBin.length; i++) {
      array.push(blobBin.charCodeAt(i));
    }
    this.croppedImage = new Blob([new Uint8Array(array)], {
      type: "image/png"
    });
  }

  get venueName(): string {
    return (this.selectedVenue !== null && this.selectedVenue.name) || "";
  }

  @Watch("selectedVenueId")
  selectedVenueIdChanged(selectedVenueId: number): void {
    if (this.$router.currentRoute.params.id === `${selectedVenueId}`) return;
    this.$router.push({
      name: "VenueImages",
      params: { id: `${selectedVenueId}` }
    });
  }
}
